import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { initAnalytics } from './utils/analytics';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Initialize Google Analytics only in production builds and when an ID is provided
const gaId = process.env.REACT_APP_GA_MEASUREMENT_ID;
const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1' ||
  window.location.hostname === '::1'
);

if (process.env.NODE_ENV === 'production' && gaId && !isLocalhost) {
  initAnalytics(gaId, { respectDoNotTrack: true, sendPageViewOnInit: true });
}

root.render(
    <App />
);
